import { useState } from "react";

export const MATCH_RULES_OPTIONS = {
  breaks: ["1", "2", "3", "4"],
  gameDuration: ["20", "30", "40", "45", "60", "90"],
  breakDuration: ["5", "10", "15", "20", "25", "30", "45", "60"],
  intervalBetweenMatches: ["5", "10", "15", "20", "25", "30", "45", "60"],
};

export const POINTS_SYSTEM_OPTIONS = {
  pointsForWin: ["1", "2", "3", "4", "5"],
  pointsForDraw: ["0", "1", "2", "3"],
  pointsForLoss: ["0", "1", "2", "3", "4", "5"],
};

export const MATCH_RULES_TEXTS = {
  breaks: {
    label: "Number of Segments per Match",
    description: "How many segments is each match split into, e.g. 2 segments (halves), 4 segments (quarters)?",
    placeholder: "1",
  },
  gameDuration: {
    label: "Duration of Each Segment",
    description: "How long does each segment last (e.g. 15 mins per half)?",
    placeholder: "30",
  },
  breakDuration: {
    label: "Half-Time / Break Duration",
    description: "How long is the break between each segment (e.g. 10 min Half-Time)?",
    placeholder: "5",
  },
  intervalBetweenMatches: {
    label: "Time Between Matches",
    description: "How much buffer time do you want between matches (e.g. for team transitions or delays)?",
    placeholder: "5",
  },
};

export const POINTS_SYSTEM_TEXTS = {
  pointsForWin: { label: "Points for a Win", description: "" },
  pointsForDraw: { label: "Points for a Draw", description: "" },
  pointsForLoss: { label: "Points for a Loss", description: "" },
};

export const MATCH_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const MATCH_TIMINGS = Array.from(
  { length: 24 },
  (_, i) => `${String(i).padStart(2, "0")}:00`
);

export const usePhaseForm = (initialState = {}) => {
  const defaultState = {
    name: "",
    bracket: "",
    inheritMatchRules: false,
    inheritMatchSchedule: false,
    useSingleStartTime: false,
    availablePitches: [],
    startAfterPreviousPhase: false,
    matchRules: {
      gameDuration: "30",
      breaks: "2",
      breakDuration: "5",
      intervalBetweenMatches: "5",
      pointsForWin: "3",
      pointsForDraw: "1",
      pointsForLoss: "0",
    },
    matchSchedule: {
      startDate: "",
      endDate: "",
      matchDays: [],
      matchTimings: [],
      startTime: "",
      dayEndTime: "",
    },
  };

  const [formData, setFormData] = useState({ ...defaultState, ...initialState });
  const [selectedTimes, setSelectedTimes] = useState([]);

  const resetForm = () => {
    setFormData(defaultState);
    setSelectedTimes([]);
  };

  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateNestedField = (parent, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [field]: value,
      },
    }));
  };

  return {
    formData,
    setFormData,
    resetForm,
    updateField,
    updateNestedField,
    selectedTimes,
    setSelectedTimes,
  };
};
